module.exports = __webpack_public_path__ + "img/logoFix.167c3873.png";